import history from 'configureHistory'

// 5 in a row
// You have edited or created an entry on 5 consecutive working days. But you can do even more, can’t you?

// 20 in a row
// You have edited or created an entry on 20 consecutive working days. Your boss will be proud of you!

// Most words 2019 in Skara
// Congratulations, you’re a legend now. You wrote the most words of all the teams in Skara in 2019.

export const userAchievements = [
	{
		key: 'personal_achievements',
		achievements: [
			{
				type: 'FIRST_ARTICLE',
				image: '/assets/img/achievements/first-article.svg',
				spotlight: true,
			},
			{
				type: 'STRUCTURE_ENTRIES',
				image: '/assets/img/achievements/structure-entries.svg',
			},
			{
				type: 'UPLOAD_PROFILE_PICTURE',
				image: '/assets/img/achievements/upload-profile-picture.svg',
				buttonCallback: () => {
					history.push({ hash: '#settings-profile' })
				},
			},
			{
				type: 'FIRST_RATING',
				image: '/assets/img/achievements/first-rating.svg',
			},
			{
				type: 'FIRST_INVITATION_SENT',
				image: '/assets/img/achievements/first-invitation-sent.svg',
			},
			{
				type: 'DARK_MODE_USED',
				image: '/assets/img/achievements/dark-mode-used.svg',
			},
			{
				type: 'WORDS_WRITTEN_1000',
				image: '/assets/img/achievements/words-written-1000.svg',
			},
			{
				type: 'WORDS_WRITTEN_10000',
				image: '/assets/img/achievements/words-written-10000.svg',
			},
			{
				type: 'WORDS_WRITTEN_100000',
				image: '/assets/img/achievements/words-written-100000.svg',
			},
		],
	},
	{
		key: 'team_achievements',
		achievements: [
			{
				type: 'UPLOAD_TEAM_PICTURE',
				image: '/assets/img/achievements/upload-team-picture.svg',
			},
			{
				type: 'TEAM_SMALL',
				image: '/assets/img/achievements/team-small.svg',
			},
			{
				type: 'TEAM_MEDIUM',
				image: '/assets/img/achievements/team-medium.svg',
			},
			{
				type: 'TEAM_LARGE',
				image: '/assets/img/achievements/team-large.svg',
			},
		],
	},
	{
		key: 'hidden_achievements',
		achievements: [
			{
				type: 'SMILEYS_USED_10',
				image: '/assets/img/achievements/smileys-used-10.svg',
			},
			{
				type: 'SMILEYS_USED_50',
				image: '/assets/img/achievements/smileys-used-50.svg',
			},
			{
				type: 'SMILEYS_USED_250',
				image: '/assets/img/achievements/smileys-used-250.svg',
			},
			{
				type: 'FIRST_REVISION_RESTORED',
				image: '/assets/img/achievements/first-revision-restored.svg',
			},
			{
				type: 'LORD_OF_THE_RINGS',
				image: '/assets/img/achievements/lord-of-the-rings.svg',
			},
			{
				type: 'ARTICLES_DELETED_100',
				image: '/assets/img/achievements/articles-deleted-100.svg',
			},
			{
				type: 'NIGHTLY_EDIT',
				image: '/assets/img/achievements/nightly-edit.svg',
			},
		],
		isHidden: true,
	},
]

export const teamAchievements = []

export const getAchievement = type => {
	const uAchievements = userAchievements.find(uA =>
		uA.achievements.find(a => a.type === type)
	)
	const tAchievements = teamAchievements.find(tA =>
		tA.achievements.find(a => a.type === type)
	)

	const achievement = uAchievements || tAchievements

	return achievement.achievements.find(a => a.type === type)
}
